import { useContext } from 'react';
import isUndefined from 'lodash/isUndefined';

import { ContextName } from '../appContext/contextName';
import AppContext from '../context';

export const useLocale = () => {
  const appContext = useContext(AppContext);
  const userSelectedLocale = appContext[ContextName.USER_SELECTED_LOCALE];
  const countryCode = appContext[ContextName.COUNTRY_CODE];

  const locale = userSelectedLocale || countryCode;

  if (isUndefined(locale)) {
    throw new Error('useLocale must be used within AppContextProvider');
  }

  return locale.toLowerCase();
};
